import React from 'react';
import './vroomapp.css';
import Map from './Map';

function App() {
  return (
    <div style={{ paddingTop: "54px" }}>
      <Map />
    </div>
  );
}

export default App;
